import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { PopoverItem, PopoverState } from '../../hooks/useItemPopover';
import { ItemDetailsPopover } from './ItemDetailsPopover';

export interface MemberTraitItem {
  id: string;
  name: string;
  description?: string | null;
}

interface MemberTraitsProps {
  traits: MemberTraitItem[];
  onItemClick?: (event: React.MouseEvent<HTMLElement>, item: PopoverItem) => void;
}

export const MemberTraits: React.FC<MemberTraitsProps> = ({ traits, onItemClick }) => {
  const [popover, setPopover] = React.useState<PopoverState | null>(null);
  if (traits.length === 0) return null;

  const handleClick = (e: React.MouseEvent<HTMLElement>, trait: MemberTraitItem) => {
    if (onItemClick) {
      onItemClick(e, { id: trait.id, name: trait.name, description: trait.description ?? '', specialTags: [] });
    } else {
      setPopover({ anchor: e.currentTarget, name: trait.name, description: trait.description ?? null, tags: [] });
    }
  };

  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 3, alignItems: 'flex-start' }}>
      <Box sx={{ flexShrink: 0 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Traits</Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start">
          {traits.map((trait) => (
            <Chip
              key={trait.id}
              size="small"
              label={trait.name}
              onClick={(e) => handleClick(e, trait)}
            />
          ))}
        </Stack>
      </Box>
      {!onItemClick && <ItemDetailsPopover popover={popover} onClose={() => setPopover(null)} />}
    </Box>
  );
};
